<template>
  <div class="flipHome pane agendaSidebar">
    <flipchart-content :extra="props.extra" />
  </div>
</template>

<script setup>
import FlipchartContent from '@/components/FlipchartContent.vue';
const props = defineProps(['extra']);
</script>
